/**
 * Project Background Effect: Blur, Scale, and Overlay
 */
declare var gsap: any;
declare var ScrollTrigger: any;

const projectBg = () => {
  const bg = document.querySelector('.project__sc-bg') as HTMLElement;
  const section = document.querySelector('.project__sc');

  if (!bg || !section) return;
  gsap.registerPlugin(ScrollTrigger);

  gsap.to(bg, {
    scale: 1.1,
    filter: 'blur(10px)',
    '--overlay-opacity': 0.2,
    scrollTrigger: {
      trigger: section,
      start: 'top',
      end: 'bottom',
      scrub: 1,
    },
  });
};

export default projectBg;
